<template>
  <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
       aria-labelledby="productModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="max-width: 800px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="productModalLabel">{{ clientName }}</h5>
          <b-button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="setClientShowData(false)">
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <div class="modal-body">
          <h6>Юридическая информация</h6>
          <div v-if="this.clientLoadData">
            <CircleProgress/>
          </div>
          <div v-if="!this.clientLoadData" style="display: flex; justify-content: space-between">
            <div class="left-side" style="width: 50%; padding-right: 20px;">
              <label for="companyName" style="font-weight: bold;">Название компании</label>
              <argon-input
                  id="companyName"
                  :value="personalData.companyName"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <label for="authorizedPerson" style="font-weight: bold;">Представитель компании</label>
              <argon-input
                  id="authorizedPerson"
                  :value="personalData.authorizedPerson"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <label for="authorityBasis" style="font-weight: bold;">Основание представительства</label>
              <argon-input
                  id="authorityBasis"
                  :value="personalData.authorityBasis"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <label for="legalAddress" style="font-weight: bold;">Юридический адрес</label>
              <argon-input
                  id="legalAddress"
                  :value="personalData.legalAddress"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />

            </div>
            <div class="right-side" style="width: 50%; padding-left: 20px;">
              <label for="companyPhone" style="font-weight: bold;">Телефон компании</label>
              <argon-input
                  id="companyPhone"
                  :value="personalData.companyPhone"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <label for="unpOrItn" style="font-weight: bold;">УНП (ИНН)</label>
              <argon-input
                  id="unpOrItn"
                  :value="personalData.unpOrItn"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />

              <label for="bankAccount" style="font-weight: bold;">Банковский счет</label>
              <argon-input
                  id="bankAccount"
                  :value="personalData.bankAccount"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />

              <div class="input-container" style="margin-top: 16px;">
                <label for="bic">БИК</label>
                <select id="bic" style="max-width: 100%;  border: 1px solid #d2d6da;
                    color: #495057;
                    border-radius: 0.5rem;
                    font-size: 0.85rem;
                    padding: 0.5rem 0.75rem;" v-model="personalData.bankBIC" disabled>
                  <option :key="null" :value="null">
                    Не выбрано
                  </option>
                  <option v-for="bankBic in bankBics" :key="bankBic" :value="bankBic">
                    {{ bankBic }}
                  </option>
                </select>
              </div>

              <div class="input-container" style="margin-top: 16px;">
                <label for="birthdate">Дата выставления счета</label>
                <input
                    id="passportIssueDate"
                    :value="personalData.invoiceDate != null ? personalData.invoiceDate.split('T')[0] : null"
                    type="date"
                    @focusin="toggleReadonly"
                    @focusout="toggleReadonly"
                    :readonly="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ArgonInput from "../../../components/ArgonInput.vue";
import CircleProgress from "../CircleProgress.vue";

export default {
  name: 'ClientLegalInfo',
  components: {CircleProgress, ArgonInput},
  data() {
    return {
      passportAuthors: [],
      passportScan: null,
      bankBics: [
        'ZEPTBY2X',
        'UNBSBY2X',
        'TECNBY22',
        'SSISBY25',
        'SLANBY22',
        'RSHNBY2X',
        'REDJBY22',
        'POISBY2X',
        'PJCBBY2X',
        'OLMPBY2X',
        'NBRBBY2X',
        'MTBKBY22',
        'MMBNBY22',
        'IRJSBY22',
        'INEARUMM',
        'EABRKZKA',
        'BRRBBY2X',
        'BPSBBY2X',
        'BLNBBY2X',
        'BLBBBY2X',
        'BISCBY25',
        'BELBBY2X',
        'BCSXBY22',
        'BBTKBY2X',
        'BAPBBY2X',
        'ALFABY2X',
        'AKBBBY2X',
        'AEBKBY2X',
        'ABIGBY25',
      ],
    };
  },
  props: {},
  computed: {
    personalData: {
      get() {
        return this.$store.state.clientLegalData;
      },
    },
    showModal: {
      get() {
        return this.$store.state.clientLegalShowData;
      }
    },
    clientLoadData: {
      get() {
        return this.$store.state.clientLegalLoadData;
      }
    },
    clientName: {
      get() {
        return this.$store.state.currentClientName;
      }
    }

  },
  methods: {

    toggleReadonly(event) {
      event.preventDefault();
      if (event.target.getAttribute('readonly') == 'readonly') {
        event.target.removeAttribute('readonly');
      } else {
        event.target.setAttribute('readonly', 'readonly');
      }
    },


    setClientShowData(active) {
      this.$store.commit('updateClientLegalShowData', active);
    },

  },
  mounted() {
  },
}
</script>

<style scoped>

#passportIssueDate {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  display: flex;
  flex-direction: column;
}

</style>